import { Component } from '@angular/core';

@Component({
  selector: 'app-sidenav-mobile',
  imports: [],
  templateUrl: './sidenav-mobile.component.html',
  styleUrl: './sidenav-mobile.component.scss',
})
export class SidenavMobileComponent {}
